import React from 'react';

const BannerImage = ({ imageName, campaignName, dataTagName }) => {
	//device HLM = Mobile, HLD = Desktop
	const getLink = (device, format) =>
		[1, 2].map((num) => {
			const scaleFactor = num > 1 ? `_${num}x` : '';
			return `//lister-merch-media.ao.com/${imageName}_${device}${scaleFactor}.${format} ${num}x`;
		});

	return (
		<picture className="block" data-tag-name={dataTagName}>
			<source
				type="image/webp"
				srcSet={getLink('HLD', 'webp')}
				media="(min-width: 768px)"
			/>
			<source
				type="image/jpeg"
				srcSet={getLink('HLD', 'jpg')}
				media="(min-width: 768px)"
			/>
			<source type="image/webp" srcSet={getLink('HLM', 'webp')} />
			<img
				srcSet={getLink('HLM', 'jpg')}
				alt={campaignName}
				className="w-full"
			/>
		</picture>
	);
};

export default BannerImage;
